module.exports = __webpack_public_path__ + "img/托管.f2838824.png";